import { render, staticRenderFns } from "./spal-blower-motors.vue?vue&type=template&id=442d5264&"
import script from "./spal-blower-motors.vue?vue&type=script&lang=js&"
export * from "./spal-blower-motors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports